import React from 'react';
import LangA from '../../../i18n/LangA';
import ChevronDown from '../../../images/navigation/chevron-down.png';
import ChevronUp from '../../../images/navigation/chevron-up.png';
import CloudflareImage from '../../cloudflare-image/CloudflareImage';
import cx from 'classnames';
import { StyledParagraph } from '../../../styles/generic/globalStyledComponents';

const NavColListItem = ({
  activeSubmenuId,
  handleSubmenuId,
  href,
  img,
  width,
  height,
  linkText,
  subtext,
  title,
  titleId,
  subTextId,
  iconId,
  subMenu,
  additionalClass,
  insideTitle,
}) => {
  const iconName = img ? img.substring(img.lastIndexOf('/') + 1, img.lastIndexOf('-')) : '';

  return (
    <li className={cx(additionalClass, `nav__dropdown-list-item ${img ? 'nav__dropdown-list-item-img' : ''}`)}>
      {img && (
        <CloudflareImage id={iconId} className={`nav__dropdown-item-img ${iconName}`} src={img} alt={title} width={width} height={height} />
      )}
      {subMenu ? (
        <div
          role="button"
          tabIndex={0}
          className="nav__dropdown-list-wrapper"
          onClick={() => {
            if (activeSubmenuId === titleId) {
              handleSubmenuId('');
            } else {
              handleSubmenuId(titleId);
            }
          }}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              if (activeSubmenuId === titleId) {
                handleSubmenuId('');
              } else {
                handleSubmenuId(titleId);
              }
            }
          }}
        >
          {linkText}
          {activeSubmenuId === titleId ? (
            <img src={ChevronUp} alt="Chevron up" width="13" />
          ) : (
            <img src={ChevronDown} alt="Chevron down" width="13" />
          )}
          <div style={{ display: activeSubmenuId === titleId ? 'block' : 'none' }} className="nav__dropdown-list-submenu">
            {subMenu?.map((item, idx) => (
              <LangA key={`${titleId}-${idx}`} id={item.titleId} href={item.href} title={item.title}>
                {item.linkText}
              </LangA>
            ))}
          </div>
        </div>
      ) : insideTitle ? (
        <StyledParagraph fontSize="13px" color="#606e7b" fontWeight="600" id={titleId}>
          {insideTitle}
        </StyledParagraph>
      ) : (
        <LangA id={titleId} href={href} title={title}>
          {linkText}
        </LangA>
      )}
      {subtext && (
        <span id={subTextId} className={'nav__dropdown-list-subtext'}>
          {subtext}
        </span>
      )}
    </li>
  );
};

export default NavColListItem;
